import React, { FC } from 'react';
import { EmailTemplate } from '../types/emailTemplates';
import { useTranslation } from 'react-i18next';
import { sanitizeTemplateHtml } from '@/features/campaigns/v2/utils/templateHtml';
import { STATUS_LABELS, STATUS_STYLES } from './config';

type EmailTemplateTableProps = {
  items: EmailTemplate[];
  onEdit: (templateId: string) => void;
  onRequestDelete: (template: EmailTemplate) => void;
};

export const EmailTemplateTable: FC<EmailTemplateTableProps> = ({ items }) => {
  const { t } = useTranslation('campaign');
  return (
    <table className='min-w-full divide-y divide-gray-200'>
      <thead className='bg-gray-50'>
        <tr>
          <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{t('whatsappTemplates.tableName')}</th>
          <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{t('whatsappTemplates.tableStatus')}</th>
          <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>
            {t('whatsappTemplates.tableLastUpdated')}
          </th>
          <th className='px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>{t('whatsappTemplates.tablePreview')}</th>
          <th className='w-32 px-4 py-3 text-left text-xs font-semibold uppercase tracking-[0.16em] text-quaternary-500'>
            {t('whatsappTemplates.tableActions')}
          </th>
        </tr>
      </thead>
      <tbody className='divide-y divide-gray-200 bg-white'>
        {items?.map((item) => (
          <tr key={item.id} className='hover:bg-gray-50'>
            <td className='px-4 py-4'>
              <p className='text-sm font-semibold text-slate-900'>{item.name}</p>
              <p className='text-xs text-secondary-500'>{item.language}</p>
            </td>
            <td className='px-4 py-4'>
              <span className={`inline-flex rounded-full px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.14em] ${STATUS_STYLES[item.status]}`}>
                {STATUS_LABELS[item.status]}
              </span>
            </td>
            <td className='px-4 py-4 text-sm text-secondary-600'>{item.updatedAt}</td>
            <td className='px-4 py-4'>
              <div className='prose prose-sm max-w-none text-sm text-secondary-600'>
                <div dangerouslySetInnerHTML={{ __html: sanitizeTemplateHtml(item.body) }} />
              </div>
            </td>
            <td className='px-4 py-4' />
          </tr>
        ))}
      </tbody>
    </table>
  );
};
